var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"id":"orcid-link","href":_vm.url,"target":"_blank"}},[_c('img',{attrs:{"alt":"ORCID logo","src":require("../assets/ORCIDiD_iconvector.svg"),"width":"24","height":"24"}}),_vm._v(" "+_vm._s(_vm.url)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }